<template>
  <main>
    <a @click.prevent="$router.go(-1)" href="#" class="link-back"><span class="icon-ico-arrow-left"></span> Add
      Prospek</a>
    <FormProspect v-model="data" @submit="onSubmit" ref="formProspect" />
  </main>
</template>
<script>
import FormProspect from "@/components/form/prospect"
import axios from '@/axios';
import { showErrorMessage } from '@/utils';

export default {
  components: {
    FormProspect
  },
  data() {
    return {
      data: {
        converter: "",
        address: "",
        commodity: "",
        application: "",
        status: "",
        description: ""
      },
    }
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.formProspect.$validator.validateAll();
      if (isValid) {
        this.$store.dispatch('toggleLoadingProgress', true)
        axios.post('/prospects', this.data).then(() => {
          this.$notify({ type: 'success', text: 'Success adding prospect' })
          this.$router.push('/prospects')
        }).catch(error => {
          showErrorMessage(error)
        }).finally(() => {
          this.$store.dispatch('toggleLoadingProgress', false)
        })
      }
    },
  }
}
</script>

<style></style>
